import React from 'react';
import {createRoutesFromElements, createBrowserRouter, Route, RouterProvider} from 'react-router-dom';
import BaseInnerLayout from './Components/shared/BaseInnerLayout';
import Pages from './Pages';
import {ROUTES} from './constants';

const Router = () => {
    return (
        <RouterProvider router={
            createBrowserRouter(
                createRoutesFromElements(
                    <React.Fragment>
                        <Route element={<BaseInnerLayout/>}>
                            <Route path={ROUTES.root} element={<Pages.BenefitsAnalysis/>}/>
                            <Route path={ROUTES.benefitsAnalysis} element={<Pages.BenefitsAnalysis/>}/>
                            <Route path={ROUTES.clientManagement} element={<Pages.ClientManagement/>}/>
                            <Route path={ROUTES.strategySandbox} element={<Pages.StrategySandbox/>}/>
                        </Route>

                        <Route path={`${ROUTES.serverError}/:errorCode`} element={<Pages.ServerError/>}/>
                        <Route path='*' element={<Pages.PageNotFound/>}/>
                    </React.Fragment>
                )
            )
        }/>
    );
};

export default Router;
